module.exports = __webpack_public_path__ + "static/media/valencia-logo.d7629f43.jpg";